const pricingDefaultState = {
  createCheckoutSessionError: null,
  hookBulkPricingError: null,
  isCreatingCheckoutSession: false,
  isRemoveCardPurpose: false,
  isCreatingCustomerPortal: false,
  loadingPlan: null,
  isOpenModalUpgradePlan: false,
  isShowingRequestAdditionalLicensePopup: false,
  promotionCode: null,
  isValidPromoCode: false,
  monthlyToYearlyUpgradePreview: null,
  yearlyRetentionOfferPreview: null,
  isUpgradingFromMonthlyToYearly: false,
  isShowMonthlyToYearlyPromoBanner: true,
  directBulkPurchaseStatus: null,
}

export default pricingDefaultState
